<div class="step-container">
  <h2 class="step-title">Foto del DNI - Dorso</h2>
  <p class="step-subtitle">Ahora posicione el dorso de su DNI dentro del recuadro y capture la foto.</p>

  <!-- Loading overlay -->
  <div *ngIf="loading" class="loading-container">
    <mat-spinner diameter="50"></mat-spinner>
    <p>Procesando DNI, esto puede demorar unos segundos...</p>
  </div>

  <!-- Camera view -->
  <div *ngIf="!loading && showWebcam && !cameraError" class="camera-container">
    <div class="webcam-wrapper">
      <webcam
        [trigger]="triggerObservable"
        (imageCapture)="onImageCaptured($event)"
        (initError)="onCameraInit($event)"
        [videoOptions]="videoOptions"
        [imageQuality]="1"
        [switchCamera]="nextWebcamObservable">
      </webcam>
      <div class="webcam-overlay"></div>
    </div>
    <button mat-fab color="primary" class="capture-button" (click)="capture()">
      <mat-icon>circle</mat-icon>
    </button>
  </div>

  <!-- Camera error -->
  <div *ngIf="!loading && cameraError" class="camera-error">
    <mat-icon class="error-icon">videocam_off</mat-icon>
    <p>{{ cameraErrorMessage }}</p>
  </div>

  <!-- Preview captured image -->
  <div *ngIf="!loading && !showWebcam && capturedImage" class="preview-container">
    <img [src]="capturedImage.imageAsDataUrl" alt="DNI Dorso" class="preview-image" />
    <div class="preview-actions">
      <button mat-stroked-button (click)="retake()">
        <mat-icon>refresh</mat-icon>
        Reintentar
      </button>
      <button mat-raised-button color="primary" (click)="confirmCapture()">
        <mat-icon>check</mat-icon>
        Confirmar y enviar
      </button>
    </div>
  </div>

  <!-- Upload from gallery -->
  <div *ngIf="!loading" class="gallery-option">
    <button mat-stroked-button class="gallery-button" (click)="openGallery()">
      <mat-icon>photo_library</mat-icon>
      Subir desde galería
    </button>
    <input
      #fileInput
      type="file"
      accept="image/*"
      hidden
      (change)="onFileSelected($event)" />
  </div>

  <!-- Error message -->
  <div *ngIf="errorMessage" class="error-message">
    <mat-icon>error_outline</mat-icon>
    <span>{{ errorMessage }}</span>
  </div>
</div>
